import { createSelector } from '@reduxjs/toolkit';
import { DirectSalesState } from 'components/common/types/DirectSalesCampaign.types';
import { isDirectSalesLinePriced } from 'components/pages/Planner/hooks/utils/getIsDirectSalesLinePriced';
import { getEveryLineState } from '../selectors';
import { getDirectSalesStatus } from './getDirectSalesStatus';

export const getAreAllLinesPriced = createSelector(
  [getDirectSalesStatus, getEveryLineState],
  (status, linesStates) =>
    isDirectSalesLinePriced(status) &&
    linesStates.every((line: DirectSalesState) => line.status && isDirectSalesLinePriced(line.status)),
);
